import { useCallback, useMemo } from "react";
import {
    applyHistoricalDataPatch,
    getSyncAttachmentsTogglePatch,
    getSyncBillsTogglePatch,
    getSyncCatalogItemsTogglePatch,
    getSyncClassesTogglePatch,
    getSyncCounterpartiesTogglePatch,
    getSyncGeneralLedgerTogglePatch,
    getSyncInvoicesTogglePatch,
    SyncTogglePatch,
    SyncToggleFields,
} from "./syncTogglePatches";

interface UseHistoricalDataTogglesParams {
    historicalData: SyncToggleFields;
    setFieldValue: (field: string, value: boolean) => void;
}

export interface HistoricalDataToggles {
    onToggleGeneralLedger: () => void;
    onToggleCounterparties: () => void;
    onToggleAttachments: () => void;
    onToggleClasses: () => void;
    onToggleCatalogItems: () => void;
    onToggleInvoices: () => void;
    onToggleBills: () => void;
}

export function useHistoricalDataToggles({
    historicalData,
    setFieldValue,
}: UseHistoricalDataTogglesParams): HistoricalDataToggles {
    const applyPatch = useCallback(
        (patch: SyncTogglePatch) => {
            applyHistoricalDataPatch({ patch, setFieldValue });
        },
        [setFieldValue],
    );

    return useMemo(
        () => ({
            onToggleGeneralLedger: () =>
                applyPatch(getSyncGeneralLedgerTogglePatch(historicalData)),
            onToggleCounterparties: () =>
                applyPatch(getSyncCounterpartiesTogglePatch(historicalData)),
            onToggleAttachments: () =>
                applyPatch(getSyncAttachmentsTogglePatch(historicalData)),
            onToggleClasses: () =>
                applyPatch(getSyncClassesTogglePatch(historicalData)),
            onToggleCatalogItems: () =>
                applyPatch(getSyncCatalogItemsTogglePatch(historicalData)),
            onToggleInvoices: () =>
                applyPatch(getSyncInvoicesTogglePatch(historicalData)),
            onToggleBills: () =>
                applyPatch(getSyncBillsTogglePatch(historicalData)),
        }),
        [applyPatch, historicalData],
    );
}
